"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAction = void 0;
var lodash_1 = require("lodash");
var core_1 = __importDefault(require("@gin-betting/core"));
var actions_1 = require("./actions");
var constants_1 = require("./constants");
var selectBets = core_1.default.entities.selectors.selectBets, UPDATE_BET = core_1.default.async.constants.UPDATE_BET;
function handleAction(state, dispatch, action, next) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, entities, betslipOddIds, betslipBetId, bets, betsInStore, betId, betInStore;
        return __generator(this, function (_b) {
            _a = action.payload, entities = _a.entities, betslipOddIds = _a.betslipOddIds, betslipBetId = _a.betslipBetId;
            bets = entities.bets;
            betsInStore = selectBets(state);
            if (!bets) {
                return [2 /*return*/, next(action)];
            }
            betId = Object.keys(bets)[0];
            if (!betId) {
                return [2 /*return*/, next(action)];
            }
            betInStore = betsInStore.get(betId);
            if (!betInStore) {
                return [2 /*return*/, next(action)];
            }
            return [2 /*return*/, dispatch(actions_1.updateBetslipOddsByBet({
                    betslipOddIds: betslipOddIds,
                    betslipBetId: betslipBetId,
                    bet: betInStore,
                }))];
        });
    });
}
exports.handleAction = handleAction;
// type UpdateBetAction = TypedAction<{
//     entities: Pick<View.NormalizedEntities, 'bets' | 'betOdds'>;
// }>;
// function handleNotEnoughBalanceError(action: UpdateBetAction): void {
//     if (action.type !== UPDATE_BET) return;
//     const bets = get(action, 'payload.entities.bets');
//     if (!bets) return;
//     const bet: View.Bet = bets[Object.keys(bets)[0]];
//     if (bet.declineReason === 'not_enough_balance') {
//         const history = getHistory();
//         const paymentUrlHash = '#popup-payments';
//         const currentUrlHash = history.location.hash;
//         if (!currentUrlHash.includes(paymentUrlHash)) {
//             // We need to trigger "onhashchange" event
//             location.hash = paymentUrlHash;
//             // history.push({ hash: paymentUrlHash });
//         }
//     }
// }
function middleware(_a) {
    var handleBet = _a.handleBet;
    return function (store) { return function (next) { return function (action) {
        var dispatch = store.dispatch, getState = store.getState;
        var state = getState();
        if (action.type === UPDATE_BET) {
            var bets = lodash_1.get(action, 'payload.entities.bets');
            if (bets) {
                var betId = Object.keys(bets)[0];
                if (betId) {
                    var bet = bets[betId];
                    handleBet(bet);
                }
            }
        }
        // this handles situation when UPDATE_BET fired before CREATE_BET_SUCCESS
        // need to fix!
        if (action.type === constants_1.CREATE_BETS_SUCCESS) {
            return handleAction(state, dispatch, action, next);
        }
        return next(action);
    }; }; };
}
exports.default = middleware;
//# sourceMappingURL=middleware.js.map